export default function LoaderReviewersGrid() {
    return (
      <div className="grid grid-cols-12 gap-2">
        {[...Array(24)].map((_, index) => (
          <div key={index} className="group col-span-12 h-[216px] animate-pulse rounded-md border-2 border-muted bg-white lg:col-span-6 xl:col-span-4"></div>
        ))}
      </div>
    )
  }
  